import React from "react";
import { Form, Row, Col, Table } from "react-bootstrap";
import "./style.css";
import { log } from "console";
import { dateConversion } from "../../../utils/formatDate";
import calenderIcon from "../../../assets/images/calenderIcon.svg"

interface FscAafDataProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const FscAafData: React.FC<FscAafDataProps> = ({ formData, setFormData }) => {
  const financialTableHeaders = [
    "",
    "Forest Products Turnover (FPT)",
    "Total Revenue (TR)",
  ];

  const financialDataConditions= [
    {
      label: "Both FPT and TR are provided AND both are reasonable.",
      checked: "Both Provided & reasonable",
      description: (
        <span className="fst-italic" style={{ fontWeight: 400, fontSize: "14px"}}>&nbsp;
          See the description of the approach, rationale, and evidence below.
        </span>
      ),
    },
    {
      label:
        "FPT is provided but TR is not provided (or TR is not reasonable)",
      checked: "FPT Provided / TR not (Provided/Reasonable)",
      description: (
        <span style={{ fontWeight: 400, fontSize: "14px" }}>&nbsp;
          The <span className="">FPT figure is reasonable</span> and does not
          involve an element of estimation.
          <span className="fst-italic">
            See description of approach, rationale, and evidence below
          </span>
        </span>
      ),
    },
    {
      label:
        "TR is provided but FPT is not provided (or FPT is not reasonable)",
      checked: "FPT not (Provided/Reasonable) / TR Provided",
      description: (
        <span style={{ fontWeight: 400, fontSize: "14px" }}>&nbsp;
          The <span className="">TR figure is reasonable.</span> The CH
          understands they will be billed AAF using the Total Revenue, according
          to the FSC Interpretations on AAF Policy.
          <span className="fst-italic">
            See the description of approach, rationale, and evidence below.
          </span>
        </span>
      ),
    },
    {
      label: "FPT and TR are provided BUT both are NOT reasonable:",
      checked: "FPT/TR Provided & both not reasonable",
      description: (
        <span style={{ fontWeight: 400, fontSize: "14px"}}>&nbsp;
          Provide a description of the inconsistencies or inaccuracies that led
          to a conclusion of unreasonableness.The default fee option which
          allowed certificate holders to waive providing TR/FPT data ended on
          December 31, 2023. Beginning January 1, 2024 Minor Non-conformities
          must be issued if the TR/FPT is not being provided or if TR/FPT is
          unreasonable.
          <span className="fst-italic">
            See the description of the approach, rationale, and evidence below.
          </span>
        </span>
      ),
    },
    {
      label: "Financial data is NOT provided.",
      checked: "Financial data is not provided",
      description: (
        <span style={{ fontWeight: 400, fontSize: "14px"}}>&nbsp;
          The default fee option which allowed certificate holders to waive
          providing TR/FPT data ended on December 31, 2023. Beginning January 1,
          2024 Minor Non-conformities must be issued if the TR/FPT is not being
          provided or if TR/FPT is unreasonable.
          <span className="fst-italic">
            See the description of the approach, rationale, and evidence below.
          </span>
        </span>
      ),
    },
  ];

  return (
    <div>
      <div className="fsc-aaf-header">
        <Form.Label className="me-2" style={{ marginBottom: "4px" }}>
          FSC AAF Data
        </Form.Label>
        <Form.Check
          type="checkbox"
          id="na-checkbox"
          label="N/A"
          className="na-checkbox"
          defaultChecked={formData.FscAafData.FSC_AAF_Data__c}
          disabled
        />
      </div>

      <div className="p-4">
        <div className="mb-1 fsc-aaf-text">
          DATA FOR MOST RECENT COMPLETED FISCAL YEAR
        </div>

        <Row className="align-items-center">
          <Col xs="auto">
            <Form.Check
            className="fsc-data-label"
              type="checkbox"
              label="N/A, Group Certification (see separate spreadsheet for values)"
              defaultChecked={formData.FscAafData.FSC_Data_Recent_FY__c}
              disabled

            />
          </Col>
        </Row>

        <Form>
          <Row className="my-3">
            <Col xs={4}>
            <div className="fsc-date-box">
              <p className="fsc-date-text">Fiscal Year Start Date:</p>
              
              <span className="fiscal-date">
              <img className="date-cal" src={calenderIcon} />
                {formData.FscAafData.FY_Start_Date__c ? dateConversion(formData.FscAafData.FY_Start_Date__c, "DD MMMM YYYY") : "--"}
              </span>
              </div>
            </Col>
            <Col xs={4}>
            <div className="fsc-date-box">
              <p className="fsc-date-text">Fiscal Year End Date:</p>
              <span className="fiscal-date">
                <img className="date-cal" src={calenderIcon} />
                {formData.FscAafData.FY_End_Date__c ? dateConversion(formData.FscAafData.FY_End_Date__c, "DD MMMM YYYY") : "--"}
              </span>
              </div>
            </Col>
            <Col xs={4}>
            <div className="d-flex mt-1">
              <p className="">Local Currency Units:&nbsp;</p>
              <span className="">
                {formData.FscAafData.FPT_Local_Currency_Unit__c || "--"}
              </span>
              </div>
            </Col>
          </Row>
        </Form>

        <Table bordered responsive className="figures-in-local-currency-table">
          <thead>
            <tr>
              {financialTableHeaders.map((header, index) => (
                <th
                  key={index}
                  className="figures-in-local-currency-table-header"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="figures-in-local-currency-table-data">
                Figures in Local Currency:
              </td>
              <td className="text-center">
                {formData.FscAafData.FPT_Turnover_Local_Currency__c || "--"}
              </td>
              <td className="text-center">
                {formData.FscAafData.Total_Revenue_Local_Currency__c || "--"}
              </td>
            </tr>
            <tr>
              <td className="figures-in-local-currency-table-data">
                Figures in US Dollars*:
              </td>
              <td className="text-center">
                {formData.FscAafData.FPT_Turnover_USD__c || "--"}
              </td>
              <td className="text-center">
                {formData.FscAafData.Total_Revenue_USD__c || "--"}
              </td>
            </tr>
          </tbody>
        </Table>
        <p className="currency-conversion-note">
          *Convert local currency into US Dollars using the fiscal year end date
          from the following page:{" "}
          <u>https://www1.oanda.com/currency/converter/</u>
        </p>

        <hr className="divider"></hr>
        <div>
          <p className="fsc-doc-note">
            See FSC&apos;s Document Centre for latest <u>AAF Policy</u> and{" "}
            <u>AAF Interpretations</u>.
          </p>

          <p className="fsc-aaf-text">
            Auditor findings when assessing reasonableness of AAF Forest
            Products Turnover figure.
          </p>
        </div>
        <div className="fsc-product-reocrd">
        <Row>
          <Col>
            <div>
              {financialDataConditions.map((option) => (
                <Form.Check
                  key={option.checked}
                >
                  <Form.Check
                    type="checkbox"
                    name={option.checked}
                    key={option.checked}
                    disabled
                    label={
                      <>
                        <u className="fsc-aaf-text">{option.label}</u>
                        <span>{option.description}</span>
                      </>
                    }
                    defaultChecked={formData.FscAafData.FPT_TR__c === option.checked}
                    className="fsc-category-check-input"
                  />
                </Form.Check>
              ))}
            </div>
          </Col>
        </Row>
        </div>
        <hr className="divider"></hr>
        <div>
          <h5 className="approach-heading">
            Approach, rationale, and supporting evidence/documentation used to
            assess reasonableness.
          </h5>
        </div>
        <div className="content-container">
          <p>
            For the above approach, rationale, and evidence section, ASI and FSC
            require detailed, specific references to your findings and evidence
            used regarding reasonableness and consistency of the organization&apos;s
            data.
          </p>
          <p>
            If the total Revenue is left blank, per the allowed circumstances in
            the Auditor Guidance document, ensure you provide a clear
            description to support this conclusion.
          </p>
          <p>
            Include key figures and exact references of document names, page
            numbers, names and titles of interviewees, sections in company
            software, etc.
          </p>
          <p className="fw-bold">
            If the organization provides different data, be sure to draw
            attention to this change in the Summary Report “Confirmation of
            Changes” section as well. This is critical to ensure we are
            collecting accurate data for FSC. Also inform your Account Manager
            or affiliate office of this change.
          </p>
          <p>
            Note the following data requirements for different types of FSC
            certificates:
          </p>

          <Row>
            <Col xs={12}>
              <ul>
                <li className="mb-3">
                  <strong className="certificate-heading">
                    Multi-site certificates:
                  </strong>{" "}
                  Financial data is aggregated across the participating site(s)
                  included in the scope of certification. Multi-site FPT does
                  not include sites that are not included on the specific
                  certificate you are evaluating.
                </li>
                <li>
                  <strong className="certificate-heading">
                    Group certificates:
                  </strong>{" "}
                  Financial data is aggregated across all Group Members. Forest
                  Products Turnover and Revenue figures are also separated by
                  Processors and Traders. For some groups, potentially there
                  could be four financial figures to report: USD$ FPT processor,
                  $ FPT trader; $ Revenue processor; $ Revenue trader. These
                  figures are reported on the Participating Sites List, not
                  here. However, you should note your evidence and findings in
                  this section.
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default FscAafData;
